
<!-- I will keep this component as a temporal wrapper  -->
<template>
  <div>
    <risk-answers-view
      :snapshot="snapshotFields"
      :answers="formData"
      :alarms-only="showAlarmsOnly"
      :collapsible="true"
      :start-collapsed="false"
      :show-comments="true"
    />
  </div>
</template>

<script>
import RiskAnswersView from "./RiskAnswersView.vue";

export default {
  name: "RiskFormAnswers",
  components: { RiskAnswersView },
  props: {
    formData: { type: [Object, Array], default: () => ({}) }, // data raw
    schema: { type: Array, default: () => [] },               // builder schema (optional)
    templateData: { type: Array, default: () => [] },         // fields template (ideal)
    showAlarmsOnly: { type: Boolean, default: false },
  },
  computed: {
    snapshotFields() {
      //we use templateData (fields with .name .section . options.alarms)
      if (Array.isArray(this.templateData) && this.templateData.length) {
        return this.templateData;
      }
      //fallback: derivate mínimun fields of schema if there is no templateData
      //We could just filter alarms if the schema has that alarm info
      const out = [];
      const visit = (nodes = [], section = "") => {
        nodes.forEach((n) => {
          if (!n) return;
          if (n.title && Array.isArray(n.children)) {
            // sección
            visit(n.children, n.title);
          } else if (n.name) {
            out.push({
              name: n.name,
              section,
              item_id: n.item_id || n.id || n.name,
              options: n.options || {}, // if containes alarms/fieldTypeCfg
            });
          }
          if (Array.isArray(n.children)) visit(n.children, section);
        });
      };
      visit(this.schema || [], "");
      return out;
    },
  },
};
</script>
